import { NgModule } from '@angular/core';
import { ListItemTagComponent } from './list-item-tag.component';

@NgModule({
    declarations: [ListItemTagComponent],
    exports: [ListItemTagComponent],
})
export class ListItemTagModule {}
